module.exports = __webpack_public_path__ + "img/casa-andina-premium-miraflores-location.5978d3f8.png";